import { TFunction } from "i18next";
import { Country } from "utils/countries";

export type AnimationImages = Record<Country, Array<HTMLImageElement>>;

const frameCount = 86;
const indexPlaceholder = "INDEX";
const languagePlaceholder = "LANGUAGE";
const parkingMeterImagePath = `${process.env.PUBLIC_URL}/assets/parkingMeterAnimation/${languagePlaceholder}/parking-meter_${indexPlaceholder}.webp`;

const getFrame = (index: number, language: string) => {
  return parkingMeterImagePath
    .replace(indexPlaceholder, index.toString().padStart(5, "0"))
    .replace(languagePlaceholder, language);
};

export const preloadImages = (
  images: AnimationImages,
  t: TFunction,
  language: Country
): void => {
  const localizedImages = images[language];

  if (localizedImages.length) {
    return;
  }

  for (let index = 0; index < frameCount; index += 1) {
    const image = new Image();

    image.src = getFrame(index, language);
    image.alt = t("10692") /* Parquímetro inteligente */;

    image.decode();
    localizedImages.push(image);
  }
};

export const getScrollTop = (): number =>
  window.scrollY ||
  document.documentElement.scrollTop ||
  document.body.scrollTop ||
  0;

export const getFrameIndex = (scrollFraction: number): number =>
  Math.max(1, Math.ceil(scrollFraction * frameCount) - 1);
